<template>
  <div class="auth-wrapper auth-reset-password">
    <div
      v-if="isCheckingToken"
      class="spinner-container"
    >
      <b-spinner variant="primary" />
    </div>
    <b-row
      v-else
      class="auth-inner m-0"
    >
      <b-col md="2" />
      <b-col
        lg="8"
        class="d-flex align-items-center justify-content-center px-2 p-lg-5"
      >

        <b-col
          v-if="tokenValid"
          sm="8"
          md="6"
          lg="7"
          class="px-xl-2 mx-auto"
        >
          <div class="login-page">
            <div class="logo-container">
              <img
                v-if="$route.query.target_package"
                src="@/assets/images/logo/verolabs-logo.png"
                alt="VEROlabs Logo"
                class="login-logo"
              >
              <b-link
                v-else
                :to="{ name: 'home' }"
              >
                <img
                  src="@/assets/images/logo/verolabs-logo.png"
                  alt="VEROlabs Logo"
                  class="login-logo"
                >
              </b-link>
            </div>
          </div>
          <validation-observer
            ref="resetForm"
            #default="{ invalid }"
          >
            <b-form
              class="auth-login-form"
              @submit.prevent="resetPassword"
            >
              <b-form-group>
                <validation-provider
                  v-slot="{ errors }"
                  name="new password"
                  vid="password"
                  rules="required"
                >
                  <div class="input-container">
                    <feather-icon
                      icon="LockIcon"
                      class="input-icon"
                      size="18"
                    />
                    <b-form-input
                      id="login-password"
                      v-model="resetForm.password"
                      :state="errors.length > 0 ? false : null"
                      :type="passwordFieldType"
                      placeholder="New Password"
                      class="login-input"
                    />
                    <feather-icon
                      class="cursor-pointer show-pass-icon"
                      :icon="passwordToggleIcon"
                      size="18"
                      @click="togglePasswordVisibility"
                    />
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  v-slot="{ errors }"
                  name="Confirm password"
                  vid="confirm-password"
                  rules="required"
                >
                  <div class="input-container">
                    <feather-icon
                      icon="LockIcon"
                      class="input-icon"
                      size="18"
                    />
                    <b-form-input
                      id="login-password"
                      v-model="resetForm.confirm_password"
                      :state="errors.length > 0 ? false : null"
                      :type="passwordFieldType"
                      placeholder="Confirm New Password"
                      class="login-input"
                    />
                    <feather-icon
                      class="cursor-pointer show-pass-icon"
                      :icon="passwordToggleIcon"
                      size="18"
                      @click="togglePasswordVisibility"
                    />
                  </div>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <div class="pt-2">
                <b-row>
                  <b-col md="12">
                    <b-button
                      type="submit"
                      variant="primary"
                      class="w-100 d-flex align-items-center justify-content-center login-btn"
                      :disabled="invalid || loadAction"
                    >
                      <feather-icon
                        icon="CheckIcon"
                        size="25"
                      />
                      <span
                        v-if="!loadAction"
                        class="ml-1"
                      >Reset password</span>
                      <b-spinner
                        v-if="loadAction"
                        type="grow"
                        small
                        class="ml-1"
                      />
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-form>
          </validation-observer>
        </b-col>
        <b-col
          v-else
          sm="8"
          md="6"
          lg="7"
          class="px-xl-2 mx-auto text-center"
        >
          <div class="login-page">
            <div class="logo-container">
              <img
                v-if="$route.query.target_package"
                src="@/assets/images/logo/verolabs-logo.png"
                alt="VEROlabs Logo"
                class="login-logo"
              >
              <b-link
                v-else
                :to="{ name: 'home' }"
              >
                <img
                  src="@/assets/images/logo/verolabs-logo.png"
                  alt="VEROlabs Logo"
                  class="login-logo"
                >
              </b-link>
            </div>
            <div class="expired-token-content">
              <feather-icon
                icon="AlertCircleIcon"
                class="text-danger"
                size="100"
              />

              <h3 class="text-white">
                {{ validationMessage }}
              </h3>
            </div>

          </div>
        </b-col>
      </b-col>
      <b-col md="2" />
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
  BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BSpinner,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      isCheckingToken: false,
      loadAction: false,
      tokenValid: true,
      validationMessage: '',
      resetForm: {
        password: '',
        password_confirmation: '',
      },
      sideImg: require('@/assets/images/pages/login.svg'),
      // Validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    token() {
      // get token from url
      return this.$route.params.token ? this.$route.params.token : null
    },

    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        return require('@/assets/images/pages/login-dark.svg')
      }
      return require('@/assets/images/pages/login.svg')
    },
  },
  mounted() {
    console.log('ResetPassword component mounted')
    this.checkToken()
  },

  methods: {
    checkToken() {
      this.isCheckingToken = true
      if (this.token && this.token !== null) {
        this.$store.dispatch('users/validateResetPasswordToken', { query: { token: this.token } }).then(response => {
          console.log('response', response)
          if (response.success == false) {
            this.tokenValid = false
            this.validationMessage = response.message
          }
        }).catch(error => {
          console.log('error', error)
        }).finally(() => {
          this.isCheckingToken = false
        })
      }
    },
    resetPassword() {
      console.log('Reset Password method called')

      // if not found then return bc you cant reset without it
      if (!this.token || this.token === null) {
        console.log('Token not found/ null valued in URL')
        return
      }
      const resetPasswordData = {
        // get passwords from input
        password: this.resetForm.password,
        confirm_password: this.resetForm.password_confirmation,
        token: this.token,
      }

      const payload = { query: resetPasswordData }
      this.$refs.resetForm
        .validate()
        .then(async success => {
          if (success) {
            this.loadAction = true

            this.$store
              .dispatch('users/resetPassword', payload)
              .then(response => {
                this.$router.push('/login')
                this.$swal({
                  icon: 'success',
                  title: '<h4>Password reset successfully!</h4>',
                  showConfirmButton: true,
                  confirmButtonColor: '#7367f0',
                  allowOutsideClick: true,
                })
                this.loadAction = false
              })
              .catch(error => {
                this.loadAction = false
                this.$swal({
                  icon: 'error',
                  title: `<h4> ${error.response.data.message} </h4>`,
                  showConfirmButton: true,
                  confirmButtonColor: '#7367f0',
                  allowOutsideClick: true,
                })
              })
            // Redirect to login page after successful reset
          } else {
            console.error('Validation failed')
          }
        })
        .catch(error => {
          console.error('Error in reset password method:', error)
        })

      // reset the form
      this.resetForm.password = null
      this.resetForm.password_confirmation = null
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

[dir] .dark-layout input.form-control,
[dir] .dark-layout .custom-file-label,
[dir] .dark-layout textarea.form-control {
  height: 45px;
  box-shadow: black beige indigo;
  border-radius: 8px;
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.4);
  background: linear-gradient(
    90deg,
    rgba(158, 63, 217, 0.2) 0%,
    rgba(37, 78, 158, 0.2) 49%,
    rgba(70, 124, 227, 0.2) 100%
  );
  border: 2px solid #ffffff3c;
  border-left: none;
  border-right: none;
  border-top: none;
}
[dir] .dark-layout input.form-control:not(:focus),
[dir] .dark-layout .custom-file-label:not(:focus),
[dir] .dark-layout textarea.form-control:not(:focus) {
  border-color: #ffffff3c;
}

.form-group span {
  position: relative;
}

.field-icon {
  position: absolute;
  top: 10px;
  left: 30px;
  color: #ffffffcc !important;
  font-weight: 500;
}
.form-control {
  padding-left: 65px;
  color: #ffffffe6 !important;
}
.form-control::placeholder {
  color: #ffffffe6 !important;
  font-size: 16px;
  margin-top: 55px !important;
  font-weight: 300 !important;
}
.show-pass-icon {
  position: absolute;
  right: 30px;
  top: 15px;
}
.forgot-pass {
  color: #ffffff70;
  text-decoration: underline;
}
.login-page {
  background: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.logo-container {
  text-align: center;
  margin-bottom: 30px;
}
.input-icon {
  position: absolute;
  left: 15px;
  color: rgba(255, 255, 255, 0.8);
}
.login-input {
  height: 50px;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  border-radius: 12px;
  color: #ffffff !important;
  padding: 0 15px 0 40px;
  width: 100%;
  transition: 0.3s ease;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
}
.form-control::placeholder {
  color: #5b5b5a !important; // Use any color you prefer
  font-size: 16px;
  margin-top: 55px !important;
  font-weight: 300 !important;
}
.expired-token-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 10px;
}
.expired-token-content h3 {
  font-size: 24px;
  font-weight: 600;
  color: #ffffff;
}
.expired-token-content p {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
}
.login-btn {
  height: 50px;
  border-radius: 12px;
  background: linear-gradient(90deg, #6c3adf 0%, #23c7ec 100%) !important;
  border: none;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;
}

.spinner-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
</style>
